import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { IStatusData } from 'src/app/shared/interfaces/statuses-map';
import { getStatusData } from 'src/app/shared/utils/tickets-table-utils';
import { ManagedServicesRepository } from '../../../../services/managed-services-repository.service';
import { IMspParentChildTicket } from '../../../interfaces/msp-parent-child-ticket';
import { IMspStatusData } from '../../../interfaces/msp-statuses-map';
import { MspTicket } from '../../../interfaces/msp-ticket';

@Component({
  selector: 'msp-ticket-detail-children',
  templateUrl: './ticket-detail-children.component.html',
  styleUrls: ['./ticket-detail-children.component.scss'],
  standalone: false,
})
export class TicketDetailChildrenComponent implements OnInit {
  /** Hold loading state for child tickets */
  @Input() isLoadingChildTickets;

  /** Hold ticket details */
  @Input() ticketDetails: MspTicket;

  /** Hold child tickets data */
  @Input() childTickets: IMspParentChildTicket[] = [];

  /** Hold msp status map for ticket header */
  @Input() statusMap: IStatusData[];

  /** Hold flag to show when fetching child tickets fails */
  @Input() apiChildTicketsFailed: boolean;

  /** Hold child tickets UI data */
  childTicketsUI: (IMspParentChildTicket & { mspStatusData: IMspStatusData })[] = [];

  constructor(private managedServiceRepository: ManagedServicesRepository) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isLoadingChildTickets'] &&
      !changes['isLoadingChildTickets'].currentValue &&
      changes['isLoadingChildTickets'].previousValue
    ) {
      this.childTicketsUI = this.childTickets.map((childTicket) => ({
        ...childTicket,
        mspStatusData: getStatusData(childTicket.statusName, childTicket.boardName, this.statusMap),
      }));
    }
  }

  /**
   * Retry fetching child tickets
   */
  retryFetchChildTickets() {
    this.apiChildTicketsFailed = false;
    this.isLoadingChildTickets = true;

    this.managedServiceRepository
      .getTicketChildren(Number(this.ticketDetails?.id))
      .pipe(
        finalize(() => {
          this.isLoadingChildTickets = false;
        }),
      )
      .subscribe({
        next: (childTickets) => {
          this.childTickets = childTickets;
          this.childTicketsUI = this.childTickets.map((childTicket) => ({
            ...childTicket,
            mspStatusData: getStatusData(childTicket.statusName, childTicket.boardName, this.statusMap),
          }));
          this.apiChildTicketsFailed = false;
        },
        error: (error) => {
          this.apiChildTicketsFailed = true;
        },
      });
  }
}
